import { ArrowRightOutlined, LeftOutlined } from '@ant-design/icons';
import { StoredBoat, useComparableBoats, useRemoveBoatFromCompare } from '@components/CompareBoats/hooks/useCompare';
import styles from '@styles/SingleBoat/Compare/compare.module.scss';
import { Button, Dropdown, Empty, Grid } from 'antd';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { FC, useCallback, useEffect, useState } from 'react';
import { MainDrawer } from '../../Header/MainDrawer';
import CompareBoatCard from './CompareBoatCard';

type Props = {};

const CompareBoats: FC<Props> = () => {
  const comparableBoats = useComparableBoats();
  const removeBoatFromCompare = useRemoveBoatFromCompare();
  const router = useRouter();

  const boatsLength = comparableBoats?.length || 0;

  const [drawer, setDrawer] = useState<boolean>(false);

  const { useBreakpoint } = Grid;
  const { xs } = useBreakpoint();

  useEffect(() => {
    if (!xs) {
      setDrawer(false);
    }
  }, [xs]);

  useEffect(() => {
    if (!boatsLength) {
      setDrawer(false);
    }
  }, [boatsLength]);

  const BoatsList = useCallback(
    () => (
      <div className={styles.dropdown__container}>
        <div className={styles.container__wrapper}>
          {boatsLength ? (
            <ul className={styles.container__menu}>
              {comparableBoats?.map((item: StoredBoat, index) => {
                if (index > 4) {
                  return null;
                }

                return (
                  <li className={styles.menu__item} key={index}>
                    <CompareBoatCard key={item.id} boat={item} removeBoat={(boat) => removeBoatFromCompare(boat)} />
                  </li>
                );
              })}
            </ul>
          ) : (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )}

          {boatsLength >= 4 && (
            <Link href="/compare" className={styles.container__more}>
              View All
            </Link>
          )}
        </div>
      </div>
    ),
    [boatsLength, comparableBoats, removeBoatFromCompare],
  );

  return (
    <>
      {xs ? (
        <Button
          onClick={() => {
            setDrawer(true);
          }}
          type="primary"
          className={styles.buttonPrimary}
        >
          Compare {`(${boatsLength})`}
          <span className={styles.arrowWrapper}>
            <ArrowRightOutlined />
          </span>
        </Button>
      ) : (
        <Dropdown trigger={['hover']} placement="bottomRight" arrow dropdownRender={() => <BoatsList />}>
          <Button type="primary" ghost className={styles.buttonPrimary} onClick={() => router.push('/compare')}>
            Compare {`(${boatsLength})`}
            <span className={styles.arrowWrapper}>
              <ArrowRightOutlined />
            </span>
          </Button>
        </Dropdown>
      )}

      <MainDrawer
        visible={drawer}
        onClose={() => {
          setDrawer(false);
        }}
        closable={false}
        className="primaryDrawer"
        goBack={false}
        head={
          <Button
            onClick={() => {
              setDrawer(false);
            }}
            type="link"
            className={styles.drawerHeaderBack}
            icon={<LeftOutlined />}
          >
            Compare {`(${boatsLength})`}
          </Button>
        }
      >
        <BoatsList />
        <div className={styles.drawer__footer}>
          <Button type="primary">
            <Link href="/compare">Compare {`(${boatsLength})`}</Link>
          </Button>
        </div>
      </MainDrawer>
    </>
  );
};

export default CompareBoats;
